import React, { Component, Fragment } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import AuditLogModal from './AuditLogModal';
import EditMetadataModal from './EditMetadataModal';
import ChangeTypeModal from './ChangeTypeModal';
import HttpClient from '../../utils/HttpClient';
import _ from 'lodash';

export default class ActionMenu extends Component {

  httpClient = new HttpClient();

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.docid = this.props.metadata['id'].value;
    this.strings = this.props.strings;
    this.state = { dropdownOpen: false };
    this.modal = React.createRef();
    this.auditModal = React.createRef();
    this.changeTypeModal = React.createRef();
  }

  toggle() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }

  delete = async () => {
   const isOk = confirm(this.strings['ConfirmDelete'] + "?");
    if (isOk) {
      this.httpClient.delete(this.docid, () => {
        this.props.deleteDocument(this.props.metadata);
      });
    }
  }

  deleteVersion = async () => {
    const isOk = confirm(this.strings['ConfirmDeleteVersion'] + "?");
     if (isOk) {
       this.httpClient.delete(this.docid, () => {}, false);
     }
   }

  download_orginial = async () => {
    await this.download(false);
  }

  download_pdf = async () => {
    await this.download(true);
  }

  download = async (pdfFormat) => {
    try {
    const url = await new HttpClient().download(this.docid, 0, true, null, pdfFormat);
    let a = document.createElement('a');
    a.href = url;
    a.download = true;    
    a.click();
    }
    catch (e) {
      if (!e) e = "Could not fetch the file";
      alert(e);
    }
  }

  audit = () => {
    this.auditModal.current.toggle();
  }

  editDocument = () => {
    this.props.editDocument(this.props.metadata);
  }

  editMetadata = () => {
    this.modal.current.toggle();
  }

  changeType = () => {
    this.changeTypeModal.current.toggle();
  }

  save = () => {
    this.props.saveDocument(this.props.metadata, this.docid);
  }

  showVersion = () => {
    const meta = _.cloneDeep(this.props.metadata);
    meta.Version.value-=1;
    if (this.props.showVersion) {
      this.props.showVersion(meta, -1);
    } else if (this.props.showDocument) {
      this.props.showDocument(meta, -1);
    }
  }

  getEdit = () => {
    const meta = this.props.metadata;
    if (meta._isEditable && meta._isEditable.value && this.props.metadata._isEditable.value) {
      return <DropdownItem onClick={this.editDocument}>Editera dokument</DropdownItem>
    }
    else {
      return (null);
    }
  }

  getDownloadPdf = () => {
    const meta = this.props.metadata;
    if (meta.Mimetype && meta.Mimetype.value && meta.Mimetype.value != "application/pdf") {
      return <DropdownItem onClick={this.download_pdf}>{this.strings['Download'] + " pdf"}</DropdownItem>
    }
    else {
      return (null);
    }
  }

  viewLastVersion = () => {

  }

  toggleLock = async () => {
    const isLocked = this.props.metadata['LockedBy'] != null && this.props.metadata['LockedBy'].value;
    try {
      if (isLocked) {
        await this.httpClient.unlock(this.docid);
        delete this.props.metadata['LockedBy'];
      } else {
        const result = await this.httpClient.lock(this.docid);
        this.props.metadata['LockedBy'] = { value: result.locked_by || 'current_user', type: 'text' };
      }
      this.props.updateDocument(this.props.metadata);
    } catch (error) {
      console.error('Failed to toggle lock:', error);
    }
  }

  getLockToggle = () => {
    const isLocked = this.props.metadata['LockedBy'] != null && this.props.metadata['LockedBy'].value;
    const label = isLocked ? this.strings['Unlock'] || 'Unlock' : this.strings['Lock'] || 'Lock';
    return <DropdownItem onClick={this.toggleLock}>{label}</DropdownItem>;
  }

  addSigner = async () => {
    const email = prompt(this.strings['EnterSignerEmail'] || 'Enter signer email:');
    if (!email) return;
    const message = prompt(this.strings['EnterMessage'] || 'Enter message (optional):') || '';
    try {
      await this.httpClient.addSigner(this.docid, email, message);
      alert(this.strings['SignerAdded'] || 'Signer added successfully');
    } catch (error) {
      console.error('Failed to add signer:', error);
    }
  }

  addViewer = async () => {
    const email = prompt(this.strings['EnterViewerEmail'] || 'Enter viewer email:');
    if (!email) return;
    try {
      await this.httpClient.addViewer(this.docid, email);
      alert(this.strings['ViewerAdded'] || 'Viewer added successfully');
    } catch (error) {
      console.error('Failed to add viewer:', error);
    }
  }

  getSignLink = () => {
    const serverUrl = this.httpClient.getServerUrl();
    const signLink = `${serverUrl}/sign?documentId=${this.docid}`;
    prompt(this.strings['SignLink'] || 'Sign link:', signLink);
  }

  getViewLink = () => {
    const serverUrl = this.httpClient.getServerUrl();
    const viewLink = `${serverUrl}/view?documentId=${this.docid}`;
    prompt(this.strings['ViewLink'] || 'View link:', viewLink);
  }

  getSigners = async () => {
    try {
      const signers = await this.httpClient.getSigners(this.docid);
      if (!signers || signers.length === 0) {
        alert(this.strings['NoSigners'] || 'No signers found');
        return;
      }
      const signerList = signers.map(s => {
        const parts = [
          `Email: ${s.email || 'N/A'}`,
          `Message: ${s.message || 'N/A'}`,
          `Signed: ${s.signed ? 'Yes' : 'No'}`,
          s.signedAt ? `Signed At: ${new Date(s.signedAt).toLocaleString()}` : null
        ].filter(Boolean);
        return parts.join('\n');
      }).join('\n\n---\n\n');
      alert((this.strings['Signers'] || 'Signers:') + '\n\n' + signerList);
    } catch (error) {
      console.error('Failed to get signers:', error);
    }
  }

  getViewers = async () => {
    try {
      const viewers = await this.httpClient.getViewers(this.docid);
      const viewerList = viewers.map(v => v.email || v).join('\n');
      alert((this.strings['Viewers'] || 'Viewers:') + '\n' + (viewerList || this.strings['NoViewers'] || 'No viewers found'));
    } catch (error) {
      console.error('Failed to get viewers:', error);
    }
  }

  renderDirectMenu() {
    const menuStyle = {
      position: 'static',
      display: 'block',
      float: 'none',
      minWidth: '200px',
      backgroundColor: '#fff',
      border: '1px solid rgba(0,0,0,.15)',
      borderRadius: '0.25rem',
      boxShadow: '0 0.5rem 1rem rgba(0,0,0,.175)',
      padding: '0.5rem 0'
    };

    const itemStyle = {
      display: 'block',
      width: '100%',
      padding: '0.25rem 1.5rem',
      clear: 'both',
      fontWeight: 400,
      color: '#212529',
      textAlign: 'left',
      whiteSpace: 'nowrap',
      backgroundColor: 'transparent',
      border: 0,
      cursor: 'pointer'
    };

    const dividerStyle = {
      height: 0,
      margin: '0.5rem 0',
      overflow: 'hidden',
      borderTop: '1px solid #e9ecef'
    };

    const meta = this.props.metadata;
    const isEditable = meta._isEditable && meta._isEditable.value;
    const isLocked = meta['LockedBy'] != null && meta['LockedBy'].value;
    const lockLabel = isLocked ? this.strings['Unlock'] || 'Unlock' : this.strings['Lock'] || 'Lock';
    const showPdf = meta.Mimetype && meta.Mimetype.value && meta.Mimetype.value != "application/pdf";

    return (
      <div className="dropdown-menu show" style={menuStyle}>
        <button style={itemStyle} onClick={this.editMetadata}>{this.strings['UpdateMetadata']}</button>
        <button style={itemStyle} onClick={this.save}>{this.strings['UpdateDocument']}</button>
        {isEditable && <button style={itemStyle} onClick={this.editDocument}>Editera dokument</button>}
        <div style={dividerStyle}></div>
        <button style={itemStyle} onClick={this.download_orginial}>{this.strings['Download'] + " orginal"}</button>
        {showPdf && <button style={itemStyle} onClick={this.download_pdf}>{this.strings['Download'] + " pdf"}</button>}
        <div style={dividerStyle}></div>
        <button style={itemStyle} onClick={this.showVersion}>{this.strings['ViewLastVersion']}</button>
        <div style={dividerStyle}></div>
        <button style={itemStyle} onClick={this.delete}>{this.strings['DeleteDocument']}</button>
        <button style={itemStyle} onClick={this.deleteVersion}>{this.strings['DeleteVersion']}</button>
        <div style={dividerStyle}></div>
        <button style={itemStyle} onClick={this.addSigner}>{this.strings['AddSigner'] || 'Add Signer'}</button>
        <button style={itemStyle} onClick={this.addViewer}>{this.strings['AddViewer'] || 'Add Viewer'}</button>
        <button style={itemStyle} onClick={this.getSigners}>{this.strings['GetSigners'] || 'Get Signers'}</button>
        <button style={itemStyle} onClick={this.getViewers}>{this.strings['GetViewers'] || 'Get Viewers'}</button>
        <button style={itemStyle} onClick={this.getSignLink}>{this.strings['GetSignLink'] || 'Get Sign Link'}</button>
        <button style={itemStyle} onClick={this.getViewLink}>{this.strings['GetViewLink'] || 'Get View Link'}</button>
        <div style={dividerStyle}></div>
        <button style={itemStyle} onClick={this.audit}>{this.strings['Auditlog']}</button>
        <button style={itemStyle} onClick={this.toggleLock}>{lockLabel}</button>
        <div style={dividerStyle}></div>
        <button style={itemStyle} onClick={this.changeType}>{this.strings['ChangeType'] || 'Change Type'}</button>
      </div>
    );
  }

  render() {
    const directMenu = this.props.directMenu || false;
    
    if (directMenu) {
      return (
        <Fragment>
          {this.renderDirectMenu()}
          <EditMetadataModal ref={this.modal} filename={this.filename} metadata={this.props.metadata}
            updateDocument={this.props.updateDocument} strings={this.strings} />
          <ChangeTypeModal ref={this.changeTypeModal} metadata={this.props.metadata}
            documentTypes={this.props.documentTypes} updateDocument={this.props.updateDocument} strings={this.strings} />
          <AuditLogModal ref={this.auditModal} audit={this.props.audit} strings={this.strings} />
        </Fragment>
      );
    }
    
    return (
      <Fragment>
        <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
          <DropdownToggle caret>
            {this.strings['Actions']}
          </DropdownToggle>
          <DropdownMenu right>
            <DropdownItem onClick={this.editMetadata}>{this.strings['UpdateMetadata']}</DropdownItem>
            <DropdownItem onClick={this.save}>{this.strings['UpdateDocument']}</DropdownItem>
            {this.getEdit()}
            <DropdownItem divider />
            <DropdownItem onClick={this.download_orginial}>{this.strings['Download'] + " orginal"}</DropdownItem>
            {this.getDownloadPdf()}
            <DropdownItem divider />
            <DropdownItem onClick={this.showVersion}>{this.strings['ViewLastVersion']}</DropdownItem>
            <DropdownItem divider />
            <DropdownItem onClick={this.delete}>{this.strings['DeleteDocument']}</DropdownItem>
            <DropdownItem onClick={this.deleteVersion}>{this.strings['DeleteVersion']}</DropdownItem>
            <DropdownItem divider />
            <DropdownItem onClick={this.addSigner}>{this.strings['AddSigner'] || 'Add Signer'}</DropdownItem>
            <DropdownItem onClick={this.addViewer}>{this.strings['AddViewer'] || 'Add Viewer'}</DropdownItem>
            <DropdownItem onClick={this.getSigners}>{this.strings['GetSigners'] || 'Get Signers'}</DropdownItem>
            <DropdownItem onClick={this.getViewers}>{this.strings['GetViewers'] || 'Get Viewers'}</DropdownItem>
            <DropdownItem onClick={this.getSignLink}>{this.strings['GetSignLink'] || 'Get Sign Link'}</DropdownItem>
            <DropdownItem onClick={this.getViewLink}>{this.strings['GetViewLink'] || 'Get View Link'}</DropdownItem>
            <DropdownItem divider />
            <DropdownItem onClick={this.audit}>{this.strings['Auditlog']}</DropdownItem>
            {this.getLockToggle()}
            <DropdownItem divider />
            <DropdownItem onClick={this.changeType}>{this.strings['ChangeType'] || 'Change Type'}</DropdownItem>
          </DropdownMenu>
        </Dropdown>
        <EditMetadataModal ref={this.modal} filename={this.filename} metadata={this.props.metadata}
          updateDocument={this.props.updateDocument} strings={this.strings} />
        <ChangeTypeModal ref={this.changeTypeModal} metadata={this.props.metadata}
          documentTypes={this.props.documentTypes} updateDocument={this.props.updateDocument} strings={this.strings} />
        <AuditLogModal ref={this.auditModal} audit={this.props.audit} strings={this.strings} />
      </Fragment>
    );
  }
}